import React from 'react';
import { connect } from 'react-redux';


export class Instructions extends React.Component {
  state = {
    open: false
  };

  _toggleOpen = (e) => {
    e.stopPropagation();
    this.setState(() => ({
      open: !this.state.open
    }));
  };

  render() {
    const { open } = this.state;
    return (
      <div className={`instructions ${open ? 'open' : ''}`}>
        <div className="container">
          <a className="toggler" onClick={this._toggleOpen} style={{ 'cursor': 'pointer' }}>
            <img
              src={`/assets/img/icon-${open ? 'minus' : 'plus'}-square.svg`}
              className="icon-expand"
            />Instructions
          </a>
        </div>
        <div className="toggle-content">
          <div className="container">{this.props.content}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  content: state.instructions.content
});

export default connect(mapStateToProps)(Instructions);


// WEBPACK FOOTER //
// ./src/components/Instructions.jsx